import React, { useState } from "react";
import { API_EMAIL_SUBSCRIBER} from "../api_constant";

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    try {
     const response = await fetch(API_EMAIL_SUBSCRIBER, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

      const data = await response.json();

      if (response.ok) {
        setSubmitted(true);
        setEmail("");
      } else {
        setError(data.error || "Subscription failed");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "60px",
        marginBottom: "30px",
        textAlign: "center",
      }}
    >
      {submitted ? (
        <p style={{ color: "green", fontSize: "18px" }}>
          ✅ Thanks! You’ll be notified when we launch.
        </p>
      ) : (
        <>
          <p style={{ fontSize: "16px", marginBottom: "20px" }}>
            Be the first to know when we launch!
          </p>
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap", // responsive for smaller screens
            }}
          >
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "350px",
                padding: "12px 16px",
                fontSize: "16px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                height: "48px",
                boxSizing: "border-box",
              }}
            />
            <button
              type="submit"
              style={{
                padding: "12px 20px",
                fontSize: "16px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#007BFF",
                color: "#fff",
                cursor: "pointer",
                height: "48px",
                whiteSpace: "nowrap",
              }}
            >
              Notify Me
            </button>
          </form>
          {error && <p style={{ color: "red", marginTop: "15px" }}>{error}</p>}
        </>
      )}
    </div>
  );
};

export default Subscribe;
